import type { Resource } from '../../';
export const cart_cartItem_genderAndSize: Resource = {"default":"{gender}, Size {size}"};
